import {v4 as uuid} from 'uuid';
import type {Datapoint} from '@deviceinsight/ng-ui-api-client';
import {InfoWidgetItem, isInfoWidgetDatapoint, isInfoWidgetProperty} from '../types';
import {getDisplayValue, formatNumber, NO_VALUE_DISPLAY} from '../InfoWidgetUtils';

const isInfoWidgetItemValid = (infoItem: InfoWidgetItem): boolean => {
	if (isInfoWidgetDatapoint(infoItem)) {
		const {datapoint} = infoItem;

		if (datapoint) {
			return datapoint.datatype !== 'DOUBLE' || decimalPointsInRange(infoItem.decimalPoints);
		} else {
			return false;
		}
	} else {
		const {propertyKey} = infoItem;
		return !!propertyKey;
	}
};

const decimalPointsInRange = (decimalPoints: number): boolean => {
	return decimalPoints >= 0 && decimalPoints <= 5;
};

const getItemKey = (infoItem: InfoWidgetItem): string => {
	if (isInfoWidgetDatapoint(infoItem) && infoItem.datapoint) {
		return `${infoItem.datapoint.name}_${uuid()}`;
	} else if (isInfoWidgetProperty(infoItem) && infoItem.propertyKey) {
		return `${infoItem.propertyKey}_${uuid()}`;
	} else {
		return uuid();
	}
};

const getItemIdentifier = (infoItem: InfoWidgetItem): string | null | undefined => {
	if (isInfoWidgetDatapoint(infoItem) && infoItem.datapoint) {
		return infoItem.datapoint.name;
	} else if (isInfoWidgetProperty(infoItem) && infoItem.propertyKey) {
		return infoItem.propertyKey;
	} else {
		return '';
	}
};

const getDatapointDisplayValue = (
	datapoint: Datapoint | null | undefined,
	decimalPoints: number,
	value: any
): string => {
	if (datapoint) {
		const unitLabel = datapoint.unit ? datapoint.unit.print : '';
		return datapoint.datatype === 'DOUBLE'
			? formatNumber(value, decimalPoints || 0, true, unitLabel, NO_VALUE_DISPLAY)
			: getDisplayValue(value, unitLabel);
	} else {
		return NO_VALUE_DISPLAY;
	}
};

const DEFAULT_ROWS = 5;
export {
	isInfoWidgetItemValid,
	decimalPointsInRange,
	getItemKey,
	getItemIdentifier,
	getDatapointDisplayValue,
	DEFAULT_ROWS
};
